module.exports = __webpack_public_path__ + "static/media/LB.f9f92d90.png";